import { LayoutGrid, Map as MapIcon, Loader2, Sparkles } from "lucide-react";
import { PROVINCE_NAME } from "../../lib/constants";
import { SaveSearchButton } from "../SaveSearchButton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export function ResultsToolbar({ t, params, total, sort, hasQuery, loading, view, setView, setParam, saveFilters }) {
  const province = params.get("province") || "all";
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
      <p className="text-slate-600 flex items-center gap-1.5" data-testid="results-count">
        <span className="font-bold text-[#12234A]">{total}</span> {t("br_results")}
        {province !== "all" && <span> {t("br_in")} {PROVINCE_NAME[province]}</span>}
        {params.get("radius") && params.get("near") && <span data-testid="results-distance"> {t("dist_within").replace("{km}", params.get("radius")).replace("{city}", params.get("near"))}</span>}
        {loading && <Loader2 size={14} className="animate-spin text-[#F5551E]" data-testid="results-refreshing" />}
      </p>
      <div className="flex items-center gap-3 flex-wrap">
        <SaveSearchButton filters={saveFilters} />
        <Select value={sort} onValueChange={(v) => setParam("sort", v)}>
          <SelectTrigger data-testid="sort-select" className="h-10 w-48 rounded-xl bg-white"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">
            {hasQuery && <SelectItem value="relevance" data-testid="sort-relevance"><span className="inline-flex items-center gap-1.5"><Sparkles size={13} className="text-[#F5551E]" />{t("br_best_match")}</span></SelectItem>}
            <SelectItem value="newest">{t("br_newest")}</SelectItem>
            <SelectItem value="oldest">{t("br_oldest")}</SelectItem>
            <SelectItem value="price_low">{t("br_price_low")}</SelectItem>
            <SelectItem value="price_high">{t("br_price_high")}</SelectItem>
          </SelectContent>
        </Select>
        <div className="flex bg-white rounded-xl border border-slate-200 p-1">
          <button onClick={() => setView("grid")} data-testid="view-grid" className={`h-8 w-8 rounded-lg flex items-center justify-center ${view === "grid" ? "bg-[#12234A] text-white" : "text-slate-500"}`}><LayoutGrid size={16} /></button>
          <button onClick={() => setView("map")} data-testid="view-map" className={`h-8 w-8 rounded-lg flex items-center justify-center ${view === "map" ? "bg-[#12234A] text-white" : "text-slate-500"}`}><MapIcon size={16} /></button>
        </div>
      </div>
    </div>
  );
}

export const DidYouMean = ({ t, word, onPick }) => (
  <div className="mb-4 flex items-center gap-2 text-sm bg-[#FFF4EE] border border-[#F5551E]/20 rounded-xl px-4 py-2.5" data-testid="did-you-mean">
    <Sparkles size={15} className="text-[#F5551E] shrink-0" />
    <span className="text-slate-600">{t("br_including")}</span>
    <button onClick={() => onPick(word)} className="font-semibold text-[#12234A] underline decoration-[#F5551E]/40 underline-offset-2 hover:text-[#F5551E]" data-testid="did-you-mean-word">{word}</button>
  </div>
);
